import { Button } from '@mantine/core';
import styles from './PrimaryContactButton.module.css';

const PrimaryContactButton = ({
  isPrimary,
  onWantsPrimary,
}: {
  isPrimary: boolean;
  onWantsPrimary: () => void;
}) => {
  return (
    <Button
      variant='outline'
      disabled={isPrimary}
      className={`${styles.primaryContactButton} ${
        isPrimary ? styles.primary : styles.notPrimary
      }`}
      size='xs'
      onClick={(e) => {
        e.stopPropagation();
        onWantsPrimary();
      }}
    >
      {isPrimary ? 'Primary contact' : 'Make primary'}
    </Button>
  );
};

export default PrimaryContactButton;
